var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFolderFilledStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.996 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 2h-8L8 0H2a2.006 2.006 0 00-2 2v12a2.006 2.006 0 002 2h16a2.006 2.006 0 002-2V4a2.006 2.006 0 00-2-2zm-2.06 11L13 11.28 10.058 13l.78-3.33-2.589-2.24 3.409-.29L13 4l1.34 3.14 3.409.29-2.589 2.24z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOS45OTYgMTYiPjxwYXRoIGQ9Ik0yMCw2SDEyTDEwLDRINEEyLjAwNiwyLjAwNiwwLDAsMCwyLDZWMThhMi4wMDYsMi4wMDYsMCwwLDAsMiwySDIwYTIuMDA2LDIuMDA2LDAsMCwwLDItMlY4QTIuMDA2LDIuMDA2LDAsMCwwLDIwLDZabS0yLjA2LDExTDE1LDE1LjI4LDEyLjA1OCwxN2wuNzgtMy4zMy0yLjU4OS0yLjI0LDMuNDA5LS4yOUwxNSw4bDEuMzQsMy4xNCwzLjQwOS4yOS0yLjU4OSwyLjI0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIgLTQpIi8+PC9zdmc+";
export { SvgFolderFilledStar as ReactComponent };